// utils/permMaps.js (o dentro de profile.js si prefieres)

// API -> UI (PlatformSettings)
export const apiPermsToPlatform = (apiPerms = {}) => {
  const out = {};
  Object.entries(apiPerms).forEach(([mod, p]) => {
    out[mod] = {
      view: !!p?.read,
      create: !!p?.create,
      edit: !!p?.update,
      delete: !!p?.delete,
    };
  });
  return out;
};

// UI -> API
export const platformToApiPerms = (uiPerms = {}) => {
  const out = {};
  Object.entries(uiPerms).forEach(([mod, p]) => {
    const read = !!p?.view || !!p?.create || !!p?.edit || !!p?.delete; // si tiene algo más, garantizamos read
    out[mod] = {
      read,
      create: !!p?.create,
      update: !!p?.edit,
      delete: !!p?.delete,
    };
  });
  return out;
};
